import { render, staticRenderFns } from "./Treasure.vue?vue&type=template&id=5bde6514&scoped=true"
import script from "./Treasure.vue?vue&type=script&lang=js"
export * from "./Treasure.vue?vue&type=script&lang=js"
import style0 from "./Treasure.vue?vue&type=style&index=0&id=5bde6514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde6514",
  null
  
)

export default component.exports